import React, { useState } from "react";
import "./NewPost.css";
import Nvabar from "./Nvabar";
import Cookies from "js-cookie";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";

const NewPost = () => {
  // structure
  const [Content, setContent] = useState("");
  const [Title, setTitle] = useState("");
  const [Tag, setTag] = useState("");
  const [image, setImage] = useState();
  const token = Cookies.get("token");
  const navigate = useNavigate();

  const postDetails = (pics) => {
    if (pics === undefined) {
      console.log("please select image");
      return;
    }
    console.log(pics);
    if (pics.type === "image/jpeg" || pics.type === "image/png") {
      const data = new FormData();
      data.append("file", pics);
      data.append("upload_preset", "chat-app");
      data.append("cloud_name", "piyushproj");
      fetch("https://api.cloudinary.com/v1_1/piyushproj/image/upload", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          setImage(data.url.toString());
          console.log(data.url.toString());
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log("please select image");

      return;
    }
  };

  //API CALL
  const request = async () => {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}post`,
        { Title, Content, Tag, image },
        config
      );
      console.log(data);
      navigate("/home");
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div className="wrapper01">
      <div className="top">
        <h1>Create New Post</h1>
      </div>
      <div className="bottom">
        <div className="bot">
          <h3>Title</h3>
          <input
            type="text"
            value={Title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="cont">
          <h3>Content</h3>
          <textarea
            type="text"
            value={Content}
            onChange={(e) => setContent(e.target.value)}
          />
          <h3>Tag</h3>
          <input
            type="text"
            value={Tag}
            onChange={(e) => setTag(e.target.value)}
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => postDetails(e.target.files[0])}
          />
          <button
            onClick={() => {
              request();
            }}
          >
            Submitt
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewPost;
